package sarka.design.skoria

import androidx.compose.runtime.Composable
import androidx.navigation.compose.rememberNavController
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.navigation.BrowserHistoryEffect
import sarka.design.skoria.navigation.SkoriaNavHost
import sarka.design.skoria.ui.theme.RCTheme

@Composable
@Preview
fun App() {
    RCTheme {
        val navController = rememberNavController()
        BrowserHistoryEffect(navController)
        SkoriaNavHost(navController = navController)
    }
}
